<template>
    <div>
        <hts-form
            :rules="CRules"
            class="space-y-6"
            @submit="handleUpdatePassword">
            <div class="flex justify-center gap-4 mt-10">
                <div class="w-[500px] flex flex-col gap-5">
                    <hts-form-input
                        v-model="form.oldPassword"
                        class="w-full"
                        :label="$t('labels.oldPassword')"
                        required
                        prop="oldPassword"
                        name="oldPassword"
                        type="password"
                        autocomplete="off" />

                    <hts-form-input
                        v-model="form.newPassword"
                        class="w-full"
                        :label="$t('labels.newPassword')"
                        required
                        prop="newPassword"
                        name="newPassword"
                        type="password"
                        autocomplete="off" />

                    <hts-form-input
                        v-model="form.confirmNewPassword"
                        class="w-full"
                        :label="$t('labels.confirmNewPassword')"
                        required
                        prop="confirmNewPassword"
                        name="confirmNewPassword"
                        type="password"
                        autocomplete="off" />

                    <div class="flex flex-row gap-5 justify-end">
                        <hts-form-button
                            icon-name="hi-x-mark-icon"
                            icon-position="right"
                            color="error"
                            @click="resetFields">
                            {{ $t('labels.cancel') }}
                        </hts-form-button>
                        <hts-form-button
                            icon-name="hi-check-icon"
                            icon-position="right"
                            color="primary"
                            type="submit">
                            {{ $t('labels.save') }}
                        </hts-form-button>
                    </div>
                </div>
            </div>
        </hts-form>
    </div>
</template>

<script setup lang="ts">
import { $lodash } from '#imports'

const initForm = {
  oldPassword: '',
  newPassword: '',
  confirmNewPassword: ''
} as {[key :string]: any}

const form = ref({ ...initForm })

const resetFields = () => {
  form.value = {
    oldPassword: null,
    newPassword: null,
    confirmNewPassword: null
  }
}

const CRules = computed(() => {
  return {
    oldPassword: form.value.oldPassword !== null ? 'required' : '',
    newPassword: form.value.newPassword !== null ? 'required|regexPassword|min:6|max:40' : 'min:6|max:40',
    confirmNewPassword: form.value.confirmNewPassword !== null ? 'required|confirmed:@newPassword' : 'confirmed:@newPassword'
  }
})

const handleUpdatePassword = async () => {
  const api = {
    url: 'admincp/auth/user/change-password',
    method: 'put'
  }
  const data = await $api(api, { body: form.value })
  const resData: any = $lodash.get(data, 'data.value')
  if (resData?.success) {
    process.client && $toast().success($t('labels.updateSuccess'))
    resetFields()
  }
}
</script>
